<template>
  <div v-if="hasPin" class="tw-flex align-items-center">
    <div class="tw-flex tw-gap-1" v-if="showPin">
      {{ pin }}
      <eye-icon class="tw-w-5 tw-h-5" @click="showPin = false" />
    </div>
    <div v-else class="tw-flex tw-gap-1">
      ••••
      <eye-slash-icon class="tw-w-5 tw-h-5" @click="getPin" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EyeIcon, EyeSlashIcon } from "@/assets/svgs";

export default {
  components: {
    EyeIcon,
    EyeSlashIcon,
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
    hasPin: Boolean,
  },
  data() {
    return {
      isLoading: false,
      pin: null,
      showPin: false,
    };
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
  },
  mounted() {
    this.EventBus.$on("business-user-updated", this.resetBusinessUserPin);
  },
  methods: {
    async getPin() {
      if (this.pin) {
        this.showPin = true;
        return;
      }
      try {
        this.isLoading = true;
        const response = await this.$axios.get(`/businesses/${this.organization.id}/users/${this.userId}/pin`);
        this.pin = response.data.pin;
        this.showPin = true;
      } catch (error) {
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Error reading pin", message: "There was an error reading the pin" });
      } finally {
        this.isLoading = false;
      }
    },
    resetBusinessUserPin({ userId }) {
      if (this.userId === userId) {
        this.showPin = false;
        this.pin = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/vars.scss";

.btn:hover {
  svg {
    color: $primary !important;
  }
}
</style>
